<template>
    <span>Live Pages</span>
</template>